import React from "react";
import { PageLayout } from "../../components/Page/PageLayout";
import { Card } from "../../components/shared/Card";
import { Section } from "../../components/Page/Section";
import { H4, Text } from "../../components/shared/typography";

// TODO: figure out neat way to reuse colors / components / typography,
// while at the same time having them wrapped in a pagelayout so they can be viewed individually
function ToSPage() {
  return (
    <PageLayout title="Mentice Live | Terms of Service" hideNavBar={true}>
      <Section title="Terms of Service" maxColumns={1}>
        <Card>
          <H4>Generic Terms of Service Template</H4>

          <Text>
            Please read these terms of service ("terms", "terms of service")
            carefully before using [website] website (the "service") operated by
            [name] ("us", 'we", "our").
          </Text>

          <H4>Conditions of Use</H4>

          <Text>
            We will provide their services to you, which are subject to the
            conditions stated below in this document. Every time you visit this
            website, use its services or make a purchase, you accept the
            following conditions. This is why we urge you to read them
            carefully.
          </Text>

          <H4>Privacy Policy</H4>

          <Text>
            Before you continue using our website we advise you to read our
            privacy policy [link to privacy policy] regarding our user data
            collection. It will help you better understand our practices.
          </Text>

          <H4>Copyright</H4>

          <Text>
            Content published on this website (digital downloads, images, texts,
            graphics, logos) is the property of [name] and/or its content
            creators and protected by international copyright laws. The entire
            compilation of the content found on this website is the exclusive
            property of [name], with copyright authorship for this compilation
            by [name].
          </Text>

          <H4>Communications</H4>

          <Text>
            The entire communication with us is electronic. Every time you send
            us an email or visit our website, you are going to be communicating
            with us. You hereby consent to receive communications from us. If
            you subscribe to the news on our website, you are going to receive
            regular emails from us. We will continue to communicate with you by
            posting news and notices on our website and by sending you emails.
            You also agree that all notices, disclosures, agreements and other
            communications we provide to you electronically meet the legal
            requirements that such communications be in writing.
          </Text>

          <H4>Applicable Law</H4>

          <Text>
            By visiting this website, you agree that the laws of the [your
            location], without regard to principles of conflict laws, will
            govern these terms of service, or any dispute of any sort that might
            come between [name] and you, or its business partners and
            associates.
          </Text>

          <H4>Disputes</H4>

          <Text>
            Any dispute related in any way to your visit to this website or to
            products you purchase from us shall be arbitrated by state or
            federal court [your location] and you consent to exclusive
            jurisdiction and venue of such courts.
          </Text>

          <H4>Comments, Reviews, and Emails</H4>

          <Text>
            Visitors may post content as long as it is not obscene, illegal,
            defamatory, threatening, infringing of intellectual property rights,
            invasive of privacy or injurious in any other way to third parties.
            Content has to be free of software viruses, political campaign, and
            commercial solicitation.
          </Text>

          <Text>
            We reserve all rights (but not the obligation) to remove and/or edit
            such content. When you post your content, you grant [name]
            non-exclusive, royalty-free and irrevocable right to use, reproduce,
            publish, modify such content throughout the world in any media.
          </Text>

          <H4>License and Site Access</H4>

          <Text>
            We grant you a limited license to access and make personal use of
            this website. You are not allowed to download or modify it. This may
            be done only with written consent from us.
          </Text>

          <H4>User Account</H4>

          <Text>
            If you are an owner of an account on this website, you are solely
            responsible for maintaining the confidentiality of your private user
            details (username and password). You are responsible for all
            activities that occur under your account or password.
          </Text>

          <Text>
            We reserve all rights to terminate accounts, edit or remove content
            and cancel orders in their sole discretion.
          </Text>
        </Card>
      </Section>
    </PageLayout>
  );
}

ToSPage.getInitialProps = () => {
  return { public: true };
};

export default ToSPage;
